var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.991 24.009a2 2 0 0 1-1.767 1.987l-.233.013h-23.16l6.578 6.59a2 2 0 0 1 .163 2.64l-.166.188a2 2 0 0 1-2.64.163l-.189-.166-9.825-9.845a1.996 1.996 0 0 1-.761-1.57l.005-.146.028-.223.023-.104c.063-.276.186-.54.368-.774l.166-.188L18.62 12.572a2 2 0 0 1 2.99 2.646l-.166.188-6.628 6.603h23.176a2 2 0 0 1 2 2z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArrowLeft);
export default __webpack_public_path__ + "static/media/icons-arrow-left.f5810f7475163b766a47e73d35ec29d3.svg";
export { ForwardRef as ReactComponent };